import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Alert
} from '@mui/material';
import userApi from '../../api/userApi';

const ForgotPasswordDialog = ({ open, onClose }) => {
    const { t } = useTranslation();
    const [mobile, setMobile] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [severity, setSeverity] = useState('success');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage(null);
        try {
            const response = await userApi.forgotPassword({ mobile });
            setMessage(response.data.message);
            setSeverity('success');
        } catch (error) {
            setMessage(error.response?.data?.message || t('common.error'));
            setSeverity('error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <form onSubmit={handleSubmit}>
                <DialogTitle>{t('common.forgot_password')}</DialogTitle>
                <DialogContent>
                    {message && (
                        <Alert severity={severity} sx={{ mb: 2 }}>
                            {message}
                        </Alert>
                    )}
                    <TextField
                        fullWidth
                        label={t('login.mobile')}
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        margin="normal"
                        required
                        autoFocus
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>{t('invoicesReport.vouchers.cancel')}</Button>
                    <Button type="submit" variant="contained" disabled={loading}>
                        {loading ? t('common.loading') : t('common.save')}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default ForgotPasswordDialog;
